export default __webpack_public_path__ + "static/media/slider-wilo-2.5643126a.jpg";